/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import QuotationBuyKanbanKit from "components/EventComponents/EventDetailsComponents/EventQuotationsBuy/QuotationBuyKanbanKit/QuotationBuyKanbanKitBody";

const QuotationBuyKanban = () => {
  useEffect(() => {
    document.title = "Quotation Buy Kanban";
  }, []);

  return (
    <main id="app">
      <Header moduleName="events" />
      <QuotationBuyKanbanKit />
    </main>
  );
};

export default QuotationBuyKanban;
